module.exports = __webpack_public_path__ + "static/img/5.b5bb082.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/sp/5.png
// module id = Aoux
// module chunks = 0